import Details from "./school_away_details.router";
import Assignment from "./school_away_assignment.router";
import Application from "./school_away_application.router";

export default [...Details, ...Assignment, ...Application];
